<template>
    <button
        class="eg-button"
        :class="[cssClass]"
        :disabled="disabled"
        @click="$emit('click')"
        @mouseover="hover = true"
        @mouseleave="hover = false"
    >
        <span>
            <slot></slot>
        </span>
        <HalfCircleSpinner
            v-if="loading"
            :animation-duration="1000"
            :size="20"
            :color="spinnerColor"
            class="preloader-wrapper"
        />
    </button>
</template>
<script>
import { HalfCircleSpinner } from 'epic-spinners';
export default {
    components: {
        HalfCircleSpinner
    },
    name: 'Button',
    props: {
        variant: {
            // eg-blue, eg-blue-outline, eg-yellow and eg-orange, eg-blue-outline-exclusive, eg-white,
            // eg-grey, eg-dark-blue, eg-dark-blue-outline
            type: String,
            default: 'eg-blue'
        },
        size: {
            // none = medium, extra-small, small, large and extra-large
            type: String,
            default: ''
        },
        block: {
            // button width 100%
            type: Boolean,
            default: false
        },
        rounded: {
            // button rounded by 20px radius
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        uppercase: {
            type: Boolean,
            default: false
        },
        shadow: {
            type: Boolean,
            default: false
        },
        positionFixed: {
            // Tipos de posições: top-left, top-right, bottom-left, bottom-right
            type: String,
            default: ''
        }
    },
    data() {
        return {
            hover: false
        };
    },
    computed: {
        cssClass() {
            return `${this.variant} ${this.size} ${this.blockClass} 
                    ${this.roundedClass} ${this.disabledClass} 
                    ${this.loadingClass} ${this.hoverClass} ${this.uppercaseClass} 
                    ${this.positionFixedClass} ${this.fixedPosition} ${this.shadowClass}`;
        },
        blockClass() {
            return this.block ? 'block' : '';
        },
        roundedClass() {
            return this.rounded ? 'rounded' : '';
        },
        disabledClass() {
            return this.disabled ? 'disabled' : '';
        },
        loadingClass() {
            return this.loading ? 'loading' : '';
        },
        hoverClass() {
            return this.hover && this.loading ? 'hover-class' : '';
        },
        uppercaseClass() {
            return this.uppercase ? 'uppercase' : '';
        },
        shadowClass() {
            return this.shadow ? 'eg-shadow' : '';
        },
        spinnerColor() {
            if (this.disabledClass) {
                return '#707070';
            } else {
                switch (this.variant) {
                case 'eg-blue':
                    return '#fff';
                case 'eg-yellow':
                    return '#000';
                case 'eg-blue-outline':
                    return '#007bff';
                default:
                    return '#000';
                }
            }
        },
        positionFixedClass() {
            if (this.positionFixed) {
                switch (this.positionFixed) {
                case 'top-left':
                    return 'eg-top-left';
                case 'top-right':
                    return 'eg-top-right';
                case 'bottom-left':
                    return 'eg-bottom-left';
                case 'bottom-right':
                    return 'eg-bottom-right';
                default:
                    return '';
                }
            }
            return '';
        },
        fixedPosition() {
            if (this.hasHeader && (this.positionFixed == 'top-left' || this.positionFixed == 'top-right')) {
                return 'eg-top-with-header';
            }
            return '';
        },
        hasHeader() {
            return this.$route.meta.isSupplier || this.$route.meta.isContractor || this.$route.meta.header != 'none';
        }
    }
};
</script>

<style lang="scss" scoped>
.eg-button {
    font-size: 16px;
    font-weight: 600;
    padding: 9px 30px;
    border: none;
    border-radius: 3px;
    box-shadow: none !important;
    position: relative;
}

/* posição fixas */

.eg-button.eg-top-left {
    position: fixed;
    top: 30px;
    left: 20px;
    z-index: 1000;
}

.eg-button.eg-top-left.eg-top-with-header,
.eg-button.eg-top-right.eg-top-with-header {
    top: 70px;
}

.eg-button.eg-top-right {
    position: fixed;
    top: 30px;
    right: 20px;
    z-index: 1000;
}

.eg-button.eg-bottom-left {
    position: fixed;
    bottom: 30px;
    left: 20px;
    z-index: 1000;
}

.eg-button.eg-bottom-right {
    position: fixed;
    bottom: 30px;
    right: 20px;
    z-index: 1000;
}

/* UpperCase */
.eg-button.uppercase {
    text-transform: uppercase !important;
}

/* botão sombreado */
.eg-button.eg-shadow {
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25) !important;
}

/* BTN PRIMARY */
.eg-button.eg-blue {
    color: #fff;
    background-color: #007bff;
    text-transform: capitalize;
}

.eg-button.eg-blue.loading span {
    color: transparent;
}

.eg-button.eg-blue:hover {
    background-color: #0545f4;
}

/* BTN SECUNDARY */

.eg-button.eg-blue-outline {
    color: #007bff;
    background-color: #fff;
    box-shadow: inset 0px 0px 1px 1px #007bff !important;
    text-transform: capitalize;
}

.eg-button.eg-blue-outline:hover {
    background-color: #007bff;
    color: #ffffff;
}

.eg-button.eg-blue-outline.hover-class:hover {
    color: #007bff;
    background-color: #fff;
    box-shadow: inset 0px 0px 1px 1px #007bff !important;
    text-transform: capitalize;
}

.eg-button.eg-blue-outline.loading span {
    color: transparent;
}
.eg-button.eg-blue-outline-exclusive {
    color: #007bff;
    background-color: #fff;
    box-shadow: inset 0px 0px 1px 1px #007bff !important;
    text-transform: capitalize;
}

.eg-button.eg-blue-outline-exclusive:hover {
    color: #007bff;
    background-color: #fff;
    box-shadow: inset 0px 0px 1px 1px #007bff !important;
    text-transform: capitalize;
}

.eg-button.eg-blue-outline-exclusive.hover-class:hover {
    color: #007bff;
    background-color: #fff;
    box-shadow: inset 0px 0px 1px 1px #007bff !important;
    text-transform: capitalize;
}

.eg-button.eg-blue-outline-exclusive.loading span {
    color: #007bff;
    background-color: #fff;
    color: transparent;
}
// dark blue
.eg-button.eg-dark-blue.loading span {
    color: transparent;
}
.eg-button.eg-dark-blue {
    padding-top: 6px;
    padding-bottom: 6px;
    color: #fff !important;
    background-color: #0e3d74;
    box-shadow: inset 0px 0px 1px 1px #0e3d74 !important;
    text-transform: capitalize;
}
.eg-button.eg-dark-blue:hover {
    color: #fff;
    background-color: #0d386a;
    box-shadow: inset 0px 0px 1px 1px #0d386a !important;
    text-transform: capitalize;
}

.eg-button.eg-dark-blue.hover-class:hover {
    color: #fff;
    background-color: #0d386a;
    box-shadow: inset 0px 0px 1px 1px #0d386a !important;
    text-transform: capitalize;
}

.eg-button.eg-dark-blue.loading span {
    color: #fff;
    background-color: #0e3d74;
    color: transparent;
}
// Dark Blue Outline
.eg-button.eg-dark-blue-outline {
    padding-top: 6px;
    padding-bottom: 6px;
    color: #0e53a5;
    background-color: #fff;
    box-shadow: inset 0px 0px 1px 1px #0e53a5 !important;
    text-transform: capitalize;
}
.eg-button.eg-dark-blue-outline:hover {
    color: #0e53a5;
    background-color: #fff;
    box-shadow: inset 0px 0px 1px 1px #0e53a5 !important;
    text-transform: capitalize;
}

.eg-button.eg-dark-blue-outline.hover-class:hover {
    color: #0e53a5;
    background-color: #fff;
    box-shadow: inset 0px 0px 1px 1px #0e53a5 !important;
    text-transform: capitalize;
}

.eg-button.eg-dark-blue-outline.loading span {
    color: #0e53a5;
    background-color: #fff;
    color: transparent;
}

/* BTN ACTION */
.eg-button.eg-yellow {
    color: #000;
    background-color: #fdc30c;
    text-transform: capitalize;
}

.eg-button.eg-yellow:hover {
    background-color: #ffb100;
}

.eg-button.eg-yellow.loading span {
    color: transparent;
}

/* BTN ORANGE */

.eg-button.eg-orange {
    color: #fff;
    background-color: #ff8f20;
    text-transform: capitalize;
}

.eg-button.eg-orange:hover {
    background-color: #fca147;
}

.eg-button.eg-orange.loading span {
    color: transparent;
}

/* EG-White */

.eg-button.eg-white {
    color: #0e3d74;
    background-color: #ffffff;
    text-transform: capitalize;
}

.eg-button.eg-white.loading span {
    color: transparent;
}

/* EG-grey */

.eg-button.eg-grey {
    color: #707070;
    background-color: #fff;
    box-shadow: inset 0px 0px 1px 1px #707070 !important;
    text-transform: capitalize;
}

.eg-button.eg-grey:hover {
    background-color: #707070;
    color: #ffffff;
}

.eg-button.eg-grey.hover-class:hover {
    color: #707070;
    background-color: #fff;
    box-shadow: inset 0px 0px 1px 1px #707070 !important;
    text-transform: capitalize;
}

.eg-button.eg-grey.loading span {
    color: transparent;
}

/* BUTTON  SIZES*/

/* SMALL */
.eg-button.small {
    padding: 4px 30px;
}

/* EXTRA SMALL */
.eg-button.extra-small {
    padding: 2px 30px;
}

/* LARGE */

.eg-button.large {
    padding: 14px 30px;
}

/* EXTRA LARGE */

.eg-button.extra-large {
    padding: 20px 30px;
    font-size: 18px;
}
/* SEND PROPOSAL */

.eg-button.send-proposal {
    height: 36px;
    font-size: 1rem;
}

/* BTN BLOCK */
.eg-button.block {
    width: 100%;
}

/* BTN ROUNDED */
.eg-button.rounded {
    border-radius: 20px;
}

/* BTN DISABLED */

.eg-button.disabled {
    background-color: #dbdbdb !important;
    color: #707070 !important;
}
.eg-button.eg-dark-blue-outline.disabled {
    background-color: #dbdbdb !important;
    color: #707070 !important;
    box-shadow: none !important;
}
.eg-button.eg-dark-blue.disabled {
    background-color: #dbdbdb !important;
    color: #707070 !important;
    box-shadow: none !important;
}

.eg-button.eg-blue-outline.disabled {
    box-shadow: none !important;
}

.eg-button.eg-blue-outline-exclusive.disabled {
    box-shadow: none !important;
}

/* CUSTOM LOADING */

.eg-button .preloader-wrapper {
    position: absolute;
    width: 20px;
    height: 20px;
    top: 10px;
    right: calc(50% - 13px);
}

.eg-button.extra-small .preloader-wrapper {
    top: 3px;
}

.eg-button.small .preloader-wrapper {
    top: 5px;
}

.eg-button.large .preloader-wrapper {
    top: 15px;
}

.eg-button.extra-large .preloader-wrapper {
    top: 25px;
}
</style>
